var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#fff",
    width: "470px",
    height: "470px",
    viewBox: "0 0 470 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-503.000000, -292.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(503.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "to-fill",
    id: "Rectangle",
    fill: "#220BAB",
    x: 0,
    y: 0,
    width: 470,
    height: 470,
    rx: 20
  }), /*#__PURE__*/React.createElement("text", {
    className: "to-color",
    id: "I-speak-English-Fren",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 64,
    fontWeight: "bold",
    "line-spacing": 70,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    y: 159
  }, "I speak"), /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    y: 229
  }, "English"), /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    y: 299
  }, "French"), /*#__PURE__*/React.createElement("tspan", {
    x: 85,
    y: 369
  }, "Allemand")), /*#__PURE__*/React.createElement("text", {
    id: "Languages-level",
    fontFamily: "AvenirNext-Medium, Avenir Next",
    fontSize: 18,
    fontWeight: 400,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 270,
    y: 441
  }, "Languages level")), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(423.000000, 428.000000)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8 0 16 8 8 16"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.c9eeb608.svg";
export { ForwardRef as ReactComponent };